import axios from 'axios'
import router from '@/router'

import { parseError, logError } from '@/utils/errorHandler'

// instance
const formRequest = axios.create({
  baseURL: process.env.VUE_APP_FORUM_HOST,
  timeout: 5000,
  headers: {'Access-Control-Allow-Origin': '*'}
});

const authRequest = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  timeout: 5000,
  headers: {'Authorization': localStorage.getItem('uid')}
});

const plainRequest = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  timeout: 5000,
});

const authInterceptor = (config) => {
  config.headers.Authorization = localStorage.getItem('uid')
  return config
}

const errorInterceptor = (error) => {
  const parsedError = parseError(error)
  
  // Log error for debugging
  logError(error.config?.url || 'API Call', parsedError)
  
  if (parsedError.statusCode === 401) {
    localStorage.removeItem('uid')
    localStorage.removeItem('user_data')
    router.push({ name: 'login' })
  }
  
  return Promise.reject(parsedError)
}

authRequest.interceptors.request.use(authInterceptor)
authRequest.interceptors.response.use(response => response, errorInterceptor)

export {authRequest, plainRequest, formRequest};